import ConfigureCredentialHandler from './credentials';
import ConfigureRequestHandler from './request';
import ConfigureServicesHandler from './services';
import copyToClipboard from './copyToClipboard';
import { TOKEN, REMEMBER_ME, API_HOST } from 'consts';
import './translation';

const {
  getToken,
  setToken,
  removeToken,
  setRememberMe,
  getRememberMe,
  removeRememberMe,
} = ConfigureCredentialHandler({
  TOKEN_KEY: TOKEN,
  REMEMBER_ME_KEY: REMEMBER_ME,
});

const { axiosInstance, getRequest, postRequest, deleteRequest, putRequest } =
  ConfigureRequestHandler({
    baseURL: API_HOST,
    getToken,
  });

const {
  serviceSigninUser,
  serviceChangePassword,
  serviceGetDashboard,
  servicePostWorkflow,
  servicePostTemplate,
  servicePutTemplate,
  serviceDeleteTemplate,
  serviceGetTemplate,
  serviceGetTemplates,
  serviceGetTemplateInteraction,
  serviceGetTemplateByProject,
  serviceGetAllTemplates,
  servicePostJobRun,
  serviceGetInventories,
  serviceGetInventory,
  servicePutInventory,
  serviceDeleteInventory,
  servicePostInventory,
  serviceGetDataModels,
  serviceGetDataModel,
  servicePostDataModel,
  servicePutDataModel,
  serviceDeleteDataModel,
  serviceGetDocuments,
  serviceGetDocument,
  serviceGetCredentials,
  serviceGetCredential,
  servicePostCredential,
  servicePutCredential,
  serviceDeleteCredential,
  serviceGetProjects,
  serviceGetProject,
  servicePostProject,
  servicePutProject,
  serviceDeleteProject,
  serviceSyncProject,
  serviceGetCompanies,
  serviceGetCompany,
  servicePostCompany,
  servicePutCompany,
  serviceDeleteCompany,
  serviceGetUsers,
  serviceGetAllParameters,
  serviceGetJobs,
  serviceGetJobRunPage,
  serviceGetJobRun,
  servicePostJobAbort,
  servicePostJobAbortAll,
  serviceGetJobStatus,
  serviceGetJobTail,
  serviceGetJobWorkflowDef,
  serviceGetPlaybooks,
  serviceGetProjectsUsers,
  serviceGetConfiguration,
  servicePutConfiguration,
  serviceGetRoles,
  serviceGetRole,
  servicePostRole,
  servicePutRole,
  serviceDeleteRole,
  serviceGetUser,
  servicePutUser,
  serviceDeleteUser,
  servicePostUser,
  serviceGetExecuteFileData,
  serviceGetConfigFiles,
  servicePostMacro,
  serviceGetApiClients,
  servicePostApiClient,
  serviceToggleApiClient,
  serviceDeleteApiClient,
  serviceGetApiTokens,
  serviceGetApiTemplates,
  servicePostApiToken,
  serviceRevokeApiToken,
  serviceDeleteApiToken,
  serviceGetApiAuditLog,
} = ConfigureServicesHandler({
  getRequest,
  postRequest,
  deleteRequest,
  putRequest,

});

export {
  getToken,
  setToken,
  removeToken,
  setRememberMe,
  getRememberMe,
  removeRememberMe,
};
export { axiosInstance, getRequest, postRequest, deleteRequest, putRequest };
export {
  serviceSigninUser,
  serviceChangePassword,
  serviceGetDashboard,
  servicePostWorkflow,
  servicePostTemplate,
  servicePutTemplate,
  serviceDeleteTemplate,
  serviceGetTemplate,
  serviceGetTemplates,
  serviceGetTemplateInteraction,
  serviceGetTemplateByProject,
  serviceGetAllTemplates,
  servicePostJobRun,
  serviceGetInventories,
  serviceGetInventory,
  servicePutInventory,
  serviceDeleteInventory,
  servicePostInventory,
  serviceGetDataModels,
  serviceGetDataModel,
  servicePostDataModel,
  servicePutDataModel,
  serviceDeleteDataModel,
  serviceGetDocuments,
  serviceGetDocument,
  serviceGetCredentials,
  serviceGetCredential,
  servicePostCredential,
  servicePutCredential,
  serviceDeleteCredential,
  serviceGetProjects,
  serviceGetProject,
  servicePostProject,
  servicePutProject,
  serviceDeleteProject,
  serviceSyncProject,
  serviceGetCompanies,
  serviceGetCompany,
  servicePostCompany,
  servicePutCompany,
  serviceDeleteCompany,
  serviceGetUsers,
  serviceGetUser,
  servicePutUser,
  serviceDeleteUser,
  servicePostUser,
  serviceGetAllParameters,
  serviceGetJobs,
  serviceGetJobRunPage,
  serviceGetJobRun,
  servicePostJobAbort,
  servicePostJobAbortAll,
  serviceGetJobStatus,
  serviceGetJobTail,
  serviceGetJobWorkflowDef,
  serviceGetPlaybooks,
  serviceGetProjectsUsers,
  serviceGetConfiguration,
  servicePutConfiguration,
  serviceGetRoles,
  serviceGetRole,
  servicePostRole,
  servicePutRole,
  serviceDeleteRole,
  serviceGetExecuteFileData,
  serviceGetConfigFiles,
  servicePostMacro,
  serviceGetApiClients,
  servicePostApiClient,
  serviceToggleApiClient,
  serviceDeleteApiClient,
  serviceGetApiTokens,
  serviceGetApiTemplates,
  servicePostApiToken,
  serviceRevokeApiToken,
  serviceDeleteApiToken,
  serviceGetApiAuditLog,
  copyToClipboard,
};
